// src/screens/admin/subadmin/SubAdmin.js
import React, { useContext, useEffect, useState } from "react";
import { Form, Button, Table, Badge } from "react-bootstrap";
import AdminLayout from "../../../layouts/admin/adminlayout/AdminLayout";
import "../../../assets/css/admin/subAdmin/SubAdmin.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import Swal from "sweetalert2";

const SubAdmin = () => {
  const { baseUrl,loggedInAdmin } = useContext(AppContext);
  // Form State
  const [adminId, setAdminId] = useState();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [isSuperAdmin, setIsSuperAdmin] = useState();
  const [apiResponseMessage, setApiResponseMessage] = useState("");
  const [apiResponseMessageColor, setApiResponseMessageColor] = useState("text-danger");
  const [isCreateUpdateLoading, setIsCreateUpdateLoading] = useState(false);
  // Edit State
  const [editId, setEditId] = useState(null);

  // Dummy Data State
  const [subAdmins, setSubAdmins] = useState([]);

  const createSubAdmin = () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("password", password);
    // formData.append("issuperAdmin", isSuperAdmin);
    formData.append("issuperAdmin", isSuperAdmin ? 1 : 0);

    axios
      .post(`${baseUrl}/admin/subAdmin/createSubAdmin`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        setApiResponseMessage(response.data.message)
        if (response.data.success == true) {
          setApiResponseMessageColor("text-success");
        } else {
          setApiResponseMessageColor("text-danger");
        }
        viewAllSubAdmin();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const updateSubAdmin = () => {
    const formData = new FormData();
    formData.append("id", adminId);
    formData.append("name", name);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("issuperAdmin", isSuperAdmin ? 1 : 0);

    axios
      .post(`${baseUrl}/admin/subAdmin/updateSubAdmin`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllSubAdmin();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteSubAdmin = (subAdmin_Id) => {
    const formData = new FormData();
    formData.append("id", subAdmin_Id);

    axios
      .post(`${baseUrl}/admin/subAdmin/deleteSubAdmin`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        viewAllSubAdmin();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const viewAllSubAdmin = () => {
    axios
      .post(`${baseUrl}/admin/subAdmin/viewAllSubAdmin`)
      .then((response) => {
        console.log(response.data);
        setSubAdmins(response.data.subAdmins);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllSubAdmin();
  }, []);

  return (
    <AdminLayout>
      <div className="subadmin-container">
        {/* Page Header */}
        <div className="page-header">
          <div className="page-header-top">
            <div>
              <h1 className="page-title">
                <span className="page-title-icon">👨‍💼</span>
                Sub Admin Management
              </h1>
              <p className="page-description">
                Add, edit, and manage sub administrators
              </p>
            </div>
          </div>
        </div>

        {/* Add/Edit Form */}
        <div className="form-section">
          <h3 className="form-title">
            {editId ? "✏️ Edit Sub Admin" : "➕ Add New Sub Admin"}
          </h3>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter name"
                value={name}
                onChange={(event) => {
                  setName(event.target.value);
                }}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter email"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Enter password"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
                required={!editId}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                name="isSuperAdmin"
                label="Is Super Admin"
                checked={isSuperAdmin}
                onChange={(event) => {
                  console.log(event.target.checked);
                  setIsSuperAdmin(event.target.checked);
                }}
              />
            </Form.Group>
            <p className={`${apiResponseMessageColor}`}>
              {apiResponseMessage}
            </p>

            <div className="form-actions">
              <Button
                onClick={() => {
                  if (editId) {
                    updateSubAdmin();
                  } else {
                    createSubAdmin();
                  }
                }
                }
                variant="primary"
                type="button"
              >
                {editId ? "✓ Update Sub Admin" : "+ Add Sub Admin"}
              </Button>
              {editId && (
                <Button
                  variant="secondary"
                  onClick={() => {
                    setEditId(null);
                    setName("");
                    setEmail("");
                    setPassword("");
                    setIsSuperAdmin(false);
                  }}
                >
                  Cancel
                </Button>
              )}
            </div>
          </Form>
        </div>

        {/* Table Section */}
        <div className="table-section">
          <h3 className="table-title">📋 All Sub Admins</h3>
          <div className="table-responsive">
            <Table bordered hover>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Is Super Admin</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {subAdmins.map((admin) => (
                  <tr key={admin.id}>
                    <td>{admin.id}</td>
                    <td>{admin.name}</td>
                    <td>{admin.email}</td>
                    <td>
                      <Badge bg={admin.issuperAdmin ? "success" : "secondary"}>
                        {admin.issuperAdmin ? "Yes" : "No"}
                      </Badge>
                    </td>
                    <td>
                      <Badge bg={admin.isActive ? "success" : "danger"}>
                        {admin.isActive ? "Active" : "Inactive"}
                      </Badge>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <Button
                          variant="warning"
                          size="sm"
                          onClick={() => {
                            if (admin.id == loggedInAdmin.id) {
                              setEditId(admin.id);
                              setAdminId(admin.id);
                              setName(admin.name);
                              setEmail(admin.email);
                              setPassword(admin.password);
                              setIsSuperAdmin(admin.issuperAdmin);
                            } else {
                                Swal.fire({
                                  icon: 'error',
                                  title: 'Unauthorized',
                                  text: 'You can only edit your own profile.',
                                });
                            }
                          }}
                          title="Edit"
                        >
                          ✏️
                        </Button>
                        <Button
                          variant={admin.isActive ? "danger" : "success"}
                          size="sm"
                          onClick={() => { }}
                          title={admin.isActive ? "Deactivate" : "Activate"}
                        >
                          {admin.isActive ? "🔒" : "🔓"}
                        </Button>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => {
                            deleteSubAdmin(admin.id)
                          }}
                          title="Delete"
                        >
                          🗑️
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default SubAdmin;
